import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
// import AddBoxIcon from '@material-ui/icons/AddBox';
// import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
// import InboxIcon from '@material-ui/icons/MoveToInbox';
// import MailIcon from '@material-ui/icons/Mail';
// import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import Card from '../../materialcomponents/Card/Card';
import GridContainer from '../../materialcomponents/Grid/GridContainer';
// import GridItem from 'src/materialcomponents/Grid/GridItem';
import CardHeader from '../../materialcomponents/Card/CardHeader';
import CardIcon from '../../materialcomponents/Card/CardIcon';
import CardFooter from '../../materialcomponents/Card/CardFooter';
import { Link } from 'react-router-dom';
// import Danger from '../../materialcomponents/Typography/Danger';
// import Warning from '../../materialcomponents/Typography/Warning';
// import Icon from '@material-ui/core/Icon';
// import Store from '@material-ui/icons/Store';
// import DateRange from '@material-ui/icons/DateRange';
// import LocalOffer from '@material-ui/icons/LocalOffer';
// import Update from '@material-ui/icons/Update';
// import Accessibility from '@material-ui/icons/Accessibility';
// import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
// import ChartistGraph from 'react-chartist';
// import * as Chartist from 'chartist';
// import styles from "src/assets/jss/material-dashboard-react/views/dashboardStyle";
import PlayCircleOutlineOutlinedIcon from '@material-ui/icons/PlayCircleOutlineOutlined';
import Button from '@material-ui/core/Button';
import { UserDetail } from 'src/reducers/user';
import { Typography } from '@material-ui/core';

export interface TabButtonProps {
    addNewOrder: () => void;
    addNewFeedback: () => void;
    liveOrder: () => void;
    completedOrder: () => void;
    manuCompletedOrder: () => void;
    filterCompletedOrder: () => void;
    liveOrderCount: string;
    completedOrderCount: string;
    onholdcount: string;
    onreturn: string;
    designready: string;
    completedcnt: string;
    goTutorial: () => void;
    userDetails: UserDetail;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rootGrid: {
            flexGrow: 1,
            height: 'auto'
        },
        butHover: {
            // backgroundColor: '#4CAF50 !important',
            transition: 'all 0.4s',
            '&:hover': {
                color: 'white',
                backgroundColor: '#dc6b6b !important',
                border: 'none',
            }
        },
        successText: {
            // color: successColor[0]
        },
        upArrowCardCategory: {
            width: '16px',
            height: '16px'
        },
        stats: {
            color: '#999',
            display: 'inline-flex',
            fontSize: '12px',
            lineHeight: '25px',
            '& svg': {
                top: '4px',
                width: '16px',
                height: '16px',
                position: 'relative',
                marginRight: '3px',
                marginLeft: '3px'
            },
            '& .fab,& .fas,& .far,& .fal,& .material-icons': {
                top: '4px',
                fontSize: '16px',
                position: 'relative',
                marginRight: '3px',
                marginLeft: '3px'
            }
        },
        cardCategory: {
            color: '#999',
            margin: '0',
            fontSize: '14px',
            marginTop: '0',
            paddingTop: '0px',
            marginBottom: '0'
        },
        cardCategoryWhite: {
            // color: 'rgba(' + hexToRgb(whiteColor) + ',.62)',
            margin: '0',
            fontSize: '14px',
            marginTop: '0',
            marginBottom: '0'
        },
        cardTitle: {
            color: '#999',
            fontSize: '0.9rem',
            marginTop: '0px',
            minHeight: 'auto',
            fontWeight: 700,
            // fontFamily: ''Roboto', 'Helvetica', 'Arial', sans-serif',
            marginBottom: '3px',
            textDecoration: 'none',
            '& small': {
                color: '#777',
                fontWeight: 400,
                lineHeight: '1'
            }
        },
        cardTitleWhite: {
            // color: whiteColor,
            marginTop: '0px',
            minHeight: 'auto',
            fontWeight: 300,
            // fontFamily: ''Roboto', 'Helvetica', 'Arial', sans-serif',
            marginBottom: '3px',
            textDecoration: 'none',
            '& small': {
                //   color: grayColor[1],
                fontWeight: 400,
                lineHeight: '1'
            }
        },
        grid: {
            padding: '0 15px !important'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            outlineStyle: 'none',
            boxShadow: 'none',
            borderColor: 'transparent',
            '& :focus': {
                outline: 'none'
            }
        },
        button: {
            padding: '0 !important',
            textTransform: 'capitalize'
        },
        tabHeight: {
            fontSize: '15px'
        },
        link: {
            textDecoration: 'none',
            color: 'currentColor'
        },
        linkDesignReady: {
            cursor: 'pointer'
        },
        number: {
            position: 'absolute',
            padding: '10px 0 !important',
            color: 'white'
        },
        marginIcon: {
            marginTop: 10
        },
        cardHeaderA: {
            display: 'flex',
            flexDirection: 'column',
            height: '74px',
        },
        gridSec: {
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            marginBottom: '15px'
        },
        popup: {
            textAlign: 'center',
        },
        btngreen: {
            backgroundColor: '#92D050',
        },
        btnorange: {
            backgroundColor: '#ffc001',
        },
        card: {
            maxWidth: 550
        }
    }),
);

export const TabButton: React.StatelessComponent<TabButtonProps> = (props) => {  
    const classes = useStyles({});

    return (
        <div>
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="baseline"
            >
                <Button
                    variant="contained"
                    color="default"
                    startIcon={<PlayCircleOutlineOutlinedIcon />}
                    onClick={props.goTutorial}
                >
                    Tutorials
                </Button>
            </Grid>
            {
                props.userDetails.ugroup === 'Lab' &&
                <GridContainer>
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/liveOrders'} className={classes.link}>
                            <Card>
                                <CardIcon color="warning" className={classes.number}>
                                    {/* <Icon>content_copy</Icon> */}
                                    <h1 className={classes.tabHeight}>{(props.liveOrderCount === '' || props.liveOrderCount === null) ? 0 : props.liveOrderCount}</h1>
                                </CardIcon>
                                <CardHeader color="warning" stats icon className={classes.cardHeaderA}>
                                    {/* <p className={classes.cardCategory}>Live Order</p> */}
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Live Orders</h1>
                                </CardHeader>
                            </Card>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/ordersOnHold'} className={classes.link}>
                            <Card>
                                <CardIcon color="rose" className={classes.number}>
                                    {/* <Accessibility /> */}
                                    <h1 className={classes.tabHeight}>{(props.onholdcount === '' || props.onholdcount === null) ? 0 : props.onholdcount}</h1>
                                </CardIcon>
                                <CardHeader color="rose" stats icon className={classes.cardHeaderA}>
                                    {/* <p className={classes.cardCategory}>Order Returned</p> */}
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Orders on Hold</h1>
                                </CardHeader>
                            </Card>
                        </Link>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>

                        <div onClick={(e) => props.filterCompletedOrder()} className={classes.linkDesignReady}>
                            <Card>
                                <CardIcon color="success" className={classes.number}>
                                    {/* <Store /> */}
                                    <h1 className={classes.tabHeight}>{(props.designready === '' || props.designready === null) ? 0 : props.designready}</h1>
                                </CardIcon>
                                <CardHeader color="success" stats icon className={classes.cardHeaderA}>
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Design Completed</h1>
                                    <Typography style={{ fontSize: '0.6rem', color: '#999' }} variant="caption">{`(Ready for download)`}</Typography>
                                </CardHeader>
                            </Card>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/inproduction'} className={classes.link}>
                            <Card>
                                <CardIcon color="info" className={classes.number}>
                                    {/* <RecordVoiceOverIcon /> */}
                                    <h1 className={classes.tabHeight}>{(props.onreturn === '' || props.onreturn === null) ? 0 : props.onreturn}</h1>
                                </CardIcon>
                                <CardHeader color="info" stats icon className={classes.cardHeaderA}>
                                    {/* <p className={classes.cardCategory}>Orders On Hold</p> */}
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>In Production</h1>
                                </CardHeader>
                            </Card>
                        </Link>
                    </Grid>
                    <Grid item lg={12} style={{ marginTop: 15 }} />
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <div onClick={(e) => props.completedOrder()} className={classes.link}>
                            <Card>
                                <CardIcon color="success" className={`${classes.number} ${classes.marginIcon}`}>
                                    {/* <Store /> */}
                                    <h1 className={classes.tabHeight}>{(props.completedOrderCount === '' || props.completedOrderCount === null) ? 0 : props.completedOrderCount}</h1>
                                </CardIcon>
                                <CardHeader color="success" stats icon className={classes.cardHeaderA}>
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Completed</h1>
                                    <Typography style={{ fontSize: '0.6rem', color: '#999' }} variant="caption">{`(All completed orders in last 7 days)`}</Typography>
                                </CardHeader>
                            </Card>
                        </div>
                    </Grid>

                </GridContainer>
            }
            {
                (props.userDetails.ugroup === 'Manufacturer' || props.userDetails.ugroup === 'EDDL') &&
                <GridContainer>
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/underdesigning'} className={classes.link}>
                            <Card>
                                <CardHeader color="warning" stats icon>
                                    <CardIcon color="warning">
                                        {/* <Icon>content_copy</Icon> */}
                                        <h1 className={classes.tabHeight}>{(props.liveOrderCount === '' || props.liveOrderCount === null) ? 0 : props.liveOrderCount}</h1>
                                    </CardIcon>
                                    {/* <p className={classes.cardCategory}>Live Order</p> */}
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Design in Progress</h1>
                                </CardHeader>
                                <CardFooter>
                                    {/* <div className={classes.stats}>
                                <AddBoxIcon />
                                Live Orders
                            </div> */}
                                </CardFooter>
                            </Card>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/casesOnHold'} className={classes.link}>
                            <Card>
                                <CardHeader color="rose" stats icon>
                                    <CardIcon color="rose">
                                        {/* <Accessibility /> */}
                                        <h1 className={classes.tabHeight}>{(props.onholdcount === '' || props.onholdcount === null) ? 0 : props.onholdcount}</h1>
                                    </CardIcon>
                                    {/* <p className={classes.cardCategory}>Order Returned</p> */}
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Cases on Hold</h1>
                                </CardHeader>
                                <CardFooter>
                                    {/* <div className={classes.stats}>
                                <Update />
                                Order Returned
                            </div> */}
                                </CardFooter>
                            </Card>
                        </Link>
                    </Grid>
                     <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <div onClick={(e) => props.manuCompletedOrder()} className={classes.link}>
                            <Card>
                                <CardIcon color="success" className={`${classes.number} ${classes.marginIcon}`}>
                                    <h1 className={classes.tabHeight}>{(props.completedcnt === '' || props.completedcnt === null) ? 0 : props.completedcnt}</h1>
                                </CardIcon>
                                <CardHeader color="success" stats icon className={classes.cardHeaderA}>
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Completed</h1>
                                    <Typography style={{ fontSize: '0.6rem', color: '#999' }} variant="caption">{`(All completed orders in last 7 days)`}</Typography>
                                </CardHeader>
                            </Card>
                        </div>
                    </Grid> 
                    
                    {/* <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/designready'} className={classes.link}>
                            <Card>
                                <CardHeader color="info" stats icon>
                                    <CardIcon color="info">
                                        <h1 className={classes.tabHeight}>{(props.onreturn === '' || props.onreturn === null) ? 0 : props.onreturn}</h1>
                                    </CardIcon>
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>Design Ready</h1>
                                </CardHeader>
                                <CardFooter>
                                </CardFooter>
                            </Card>
                        </Link>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} className={classes.grid}>
                        <Link to={'/app/caseInproduction'} className={classes.link}>
                            <Card>
                                <CardHeader color="success" stats icon>
                                    <CardIcon color="success">
                                        <h1 className={classes.tabHeight}>{(props.completedOrderCount === '' || props.completedOrderCount === null) ? 0 : props.completedOrderCount}</h1>
                                    </CardIcon>
                                    <p className={classes.cardCategory}>&nbsp;</p>
                                    <h1 className={classes.cardTitle}>In Production</h1>
                                </CardHeader>
                                <CardFooter >
                                </CardFooter>
                            </Card>
                        </Link>
                    </Grid> */}
                </GridContainer>
            }
        </div>

        // <div className={classes.rootGrid}>
        //     <Grid container spacing={6} justify="space-evenly">
        //         <Grid item xs={8} sm={3} md={3} spacing={3}>
        //             <Button className={classes.butHover} fullWidth variant="outlined" onClick={props.addNewOrder} color="primary">&nbsp;<AddBoxIcon />&nbsp;New&nbsp;Order</Button>
        //         </Grid>
        //         <Grid item xs={8} sm={3} md={3} spacing={3}>
        //             <Button className={classes.butHover} fullWidth variant="outlined" color="primary">&nbsp;<AddShoppingCartIcon />&nbsp;My&nbsp;Orders&nbsp;</Button>
        //         </Grid>
        //         <Grid item xs={8} sm={3} md={3} spacing={3}>
        //             <Button className={classes.butHover} fullWidth variant="outlined" color="primary">&nbsp;<RecordVoiceOverIcon />&nbsp;Reports</Button>
        //         </Grid>
        //         <Grid item xs={8} sm={3} md={3} spacing={3}>
        //             <Button className={classes.butHover} fullWidth variant="outlined" color="primary" onClick={props.addNewFeedback}><MailIcon />&nbsp;Feedback</Button>
        //         </Grid>
        //     </Grid>
        // </div>

    );
};

export default TabButton;



// WEBPACK FOOTER //
// ./src/components/layouts/TabButton.tsx